<template xmlns="http://www.w3.org/1999/html">
    <div>
        <h2>{{ step.title }}</h2>
        <p class="step__notice">
            All fields with an asterisk are required
            <i class="fas fa-asterisk"></i>
        </p>
        <h4>What are benefits?</h4>
        <p>Benefits include any financial support received from the UK Government for those who are unemployed, 
            looking for work or in low-earning jobs. Assistance is also provided to people if they have a disability, 
            are bringing up children or care for someone who is ill.</p><br>
            <h4>Types of benefits include:</h4>
            <ul>
                <li>Income support</li>
                <li>Housing Benefit</li>
                <li>Employment and Support Allowance</li>
                <li>Job Seekers Allowance</li>
                <li>Universal Credit</li>
                <li>Other (e.g. carers allowance, maternity allowance, Personal Independent Allowance, Council Tax Benefit)</li>
            </ul>
        
        <InputRadioGroup
            name="Benefit_Question"
            :required="checkIsRequired('Benefit_Question')"
            :error="formRef.errors.get('Benefit_Question')"
            v-model="formRef.Benefit_Question"
            :options="getField('Benefit_Question')['options']"
        >
            <template v-slot:question>
                {{ getField("Benefit_Question").question }}
            </template>
        </InputRadioGroup>

       
    </div>
</template>

<script setup>
import InputRadioGroup from "../Form/InputRadioGroup.vue";
import Form from "../../../js/Form";
import { isRequired } from "../Application/formHelper";
import { ref, markRaw } from "vue";

const emit = defineEmits('button-updated')

const props = defineProps({
    step: Object,
    fields: Object,
    formData: Object
})

let formRef = markRaw(ref(new Form({
    Benefit_Question: null
}, {...props.formData})))

const getField = (fieldName) => {
   return props.fields[fieldName];
}

const checkIsRequired = (fieldName) => {
   var fieldData = getField(fieldName);
   return isRequired(fieldData, formRef.value);
}

function previewFiles() {
    emit("button-updated", document.getElementById("document-upload").value);
}

defineExpose({
    formRef
})
</script>
